import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "relative w-full h-full flex-grow flex overflow-hidden" }
const _hoisted_2 = {
  key: 0,
  class: "min-h-300 absolute top-0 left-0 right-0 bottom-0 flex flex-col items-center justify-center gap-4"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Loading virtual mailbox...", -1)
const _hoisted_4 = { class: "flex flex-col overflow-auto flex-grow h-full scrollbar gap-4 pb-4" }
const _hoisted_5 = { class: "max-w-sm" }
const _hoisted_6 = {
  key: 0,
  class: "max-w-sm"
}
const _hoisted_7 = { class: "max-w-sm" }
const _hoisted_8 = { class: "max-w-sm" }
const _hoisted_9 = { class: "w-full mb-4 max-w-sm" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  class: "mb-3 block",
  htmlFor: "assigned_box_number"
}, " Unit Number ", -1)
const _hoisted_11 = { class: "flex w-full" }
const _hoisted_12 = { class: "flex flex-col pt-1" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs" }, "Choose a number between 0001-5000", -1)
const _hoisted_14 = { class: "max-w-sm" }
const _hoisted_15 = { class: "max-w-sm" }
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<div class=\"lg:w-100 w-120 h-full border-solid border-0 border-l outline-none details-block flex flex-col gap-4 p-4 flex-shrink-0\"><p>Virtual Mailbox Overview</p><p class=\"text-13\"> Setup a virtual mailbox in one of our secure mail processing facilities. </p><ul class=\"text-13 list-disc pl-4\"><li class=\"mb-1\"> Mail is scanned within 24 hours of receipt (usually faster) </li><li class=\"mb-1\"> Set your team members that have access to this mailbox </li><li class=\"mb-1\"> Any mail can be selected for forwarding to your address of your choosing for a $1.50 fee + cost of shipping </li><li class=\"mb-1\"> Email notifications can be sent to the team when new mail arrives as either the full PDF or a link back to Thatch for more secure viewing </li></ul></div>", 1)

import { useRoute, useRouter } from 'vue-router';
import {
	required,
	requiredIf
} from '@vuelidate/validators';
import { computed } from 'vue';
import {
	UiLoader,
	UiCard,
	UiCardDivider,
	useForm,
	UiForm,
	UiInput,
	UiRadioTabs,
	UiButton,
	UiSelect,
	SelectOptions,
	UiFormError,
	useConfirmation
} from '@/ui-kit';
import { useVirtualMailbox } from '../use-virtual-mailbox';
import VirtualMailboxTeamMembers from '../components/VirtualMailboxTeamMembers.vue';
import { Nullable } from '@/utils';
import { useToggle } from '@vueuse/core';
import { useToast } from 'vue-toastification';
import { useBilling } from '@/billing';
import { useCompanyProfile } from '@/account';


export default /*#__PURE__*/_defineComponent({
  __name: 'EditVirtualMailbox',
  setup(__props) {

const {
	isLoading,
	locations,
	items,
	deleteMailboxItem,
	updateMailboxItem
} = useVirtualMailbox();
const { currentSubItems } = useBilling();
const { isPaidAccount } = useCompanyProfile();

const virtualMailboxSubscriptions = computed(() => {
	return currentSubItems.value
		.filter(
			(item) =>
				item.subscriptionName ===
					'virtual-mail-system' &&
				items.value.filter(
					(mailbox) =>
						mailbox.id !==
							selectedMailbox.value?.id &&
						mailbox.subscription_item
							.stripe_product ===
							item.stripe_product
				).length < item.quantity
		)
		.map((item) => ({
			value: item.id,
			title: item.friendlyName
		}));
});

const route = useRoute();
const selectedMailbox = computed(() => {
	return items.value.find(
		(item) => item.id === Number(route.params.id)
	);
});

const {
	formData,
	validator,
	onSubmit,
	loading,
	fillFormData
} = useForm(
	{
		friendly_name: '',
		assigned_box_number: null as Nullable<number>,
		auto_ocr: 1,
		allow_pdf_to_team: 1,
		physical_address_id: route.params.location
			? Number(route.params.location)
			: (null as Nullable<number>),
		subscription_item_id: null as Nullable<number>
	},
	{
		friendly_name: {
			required
		},
		assigned_box_number: {
			required
		},
		auto_ocr: {
			required
		},
		allow_pdf_to_team: {
			required
		},
		physical_address_id: {
			required
		},
		subscription_item_id: {
			required: requiredIf(() => isPaidAccount.value)
		}
	}
);

fillFormData({
	friendly_name: selectedMailbox.value!.friendly_name,
	assigned_box_number:
		selectedMailbox.value!.assigned_box_number.replace(
			'T1-',
			''
		),
	physical_address_id:
		selectedMailbox.value!.physical_location.id,
	allow_pdf_to_team: Number(
		selectedMailbox.value!.allow_pdf_to_team
	),
	auto_ocr: Number(selectedMailbox.value!.auto_ocr),
	subscription_item_id:
		selectedMailbox.value?.subscription_item?.id || null
});

const options = computed<SelectOptions>(() => {
	return locations.value.map((loc) => ({
		title: `${loc.line}, ${loc.city} ${loc.state} ${loc.zip}`,
		value: loc.id
	}));
});

const hasUntNumberError = computed(() => {
	return validator.value.assigned_box_number.$error;
});

const yesNoOption: SelectOptions = [
	{
		title: 'Yes',
		value: 1
	},
	{
		title: 'No',
		value: 0
	}
];

const { openConfirmation, closeConfirmation } =
	useConfirmation();
const router = useRouter();
const [isDeleting, setIsLoading] = useToggle();
const toast = useToast();

async function triggerDeleteVirtualMailbox() {
	const result = await openConfirmation(
		'Are you sure you want to remove this virtual mailbox',
		"You won't be able to use it to receive virtual mails on this box. Your subscription will decrement on deleted item.",
		{
			isLoading: computed(() => isDeleting.value)
		}
	);

	if (!result || !selectedMailbox.value) {
		return;
	}

	setIsLoading(true);
	await deleteMailboxItem(selectedMailbox.value);
	closeConfirmation();
	toast.success('Virtual mail box removed');
	router.replace({ name: 'VirtualMailbox' });
}

const submit = onSubmit((data) => {
	if (isPaidAccount.value) {
		return updateMailboxItem(
			selectedMailbox.value!.id,
			data
		);
	}

	const { subscription_item_id, ...payload } = data;

	return updateMailboxItem(
		selectedMailbox.value!.id,
		payload
	);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(UiCard), {
      title: "Virtual Mailbox",
      class: "w-full p-4",
      "content-class": "flex-grow flex flex-col h-full overflow-hidden"
    }, {
      default: _withCtx(() => [
        (_unref(isLoading))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              _createVNode(_unref(UiLoader))
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(_unref(UiCardDivider), { title: "Edit virtual mailbox" }),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_unref(UiForm), {
                  onSubmit: _unref(submit),
                  class: "flex flex-col gap-4"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_unref(UiInput), {
                        disabled: _unref(loading),
                        label: "Name",
                        placeholder: "Enter friendly name",
                        name: "friendly_name",
                        modelValue: 
									_unref(formData).friendly_name
								,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((
									_unref(formData).friendly_name
								) = $event))
                      }, null, 8, ["disabled", "modelValue"])
                    ]),
                    (_unref(isPaidAccount))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createVNode(_unref(UiSelect), {
                            name: "subscription_item_id",
                            noValidate: "",
                            label: "Subscription",
                            placeholder: "Select subscription",
                            modelValue: 
									_unref(formData).subscription_item_id
								,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((
									_unref(formData).subscription_item_id
								) = $event)),
                            options: 
									_unref(virtualMailboxSubscriptions)
								,
                            disabled: 
									_unref(virtualMailboxSubscriptions).length ===
										1 || _unref(loading)
								
                          }, null, 8, ["modelValue", "options", "disabled"])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_unref(UiButton), { loading: _unref(loading) }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Save Changes ")
                        ]),
                        _: 1
                      }, 8, ["loading"])
                    ])
                  ]),
                  _: 1
                }, 8, ["onSubmit"]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_unref(UiSelect), {
                    disabled: "",
                    label: "Location",
                    placeholder: "Choose location",
                    name: "physical_address_id",
                    modelValue: 
								_unref(formData).physical_address_id
							,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((
								_unref(formData).physical_address_id
							) = $event)),
                    options: _unref(options)
                  }, null, 8, ["modelValue", "options"])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["flex-shrink-0 pl-3 pr-6 border-0 transition border-0 border-b border-l border-t border-solid h-9.5 flex items-center bg-dark-blue-300 bg-opacity-25", 
									_unref(hasUntNumberError)
										? 'border-red-400'
										: 'border-dark-blue-300'
								])
                    }, " T1 - ", 2),
                    _createVNode(_unref(UiInput), {
                      disabled: "",
                      class: "!mb-0 w-full",
                      noValidate: "",
                      name: "assigned_box_number",
                      placeholder: "Enter unit number",
                      modelValue: 
									_unref(formData).assigned_box_number
								,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((
									_unref(formData).assigned_box_number
								) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _createVNode(_unref(UiFormError), { name: "assigned_box_number" })
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_unref(UiRadioTabs), {
                    disabled: "",
                    label: "Auto-OCR Incoming Mail",
                    name: "auto_ocr",
                    options: yesNoOption,
                    modelValue: _unref(formData).auto_ocr,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(formData).auto_ocr) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_unref(UiRadioTabs), {
                    disabled: "",
                    label: "Allow PDF Email to Team",
                    name: "allow_pdf_to_team",
                    modelValue: 
								_unref(formData).allow_pdf_to_team
							,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((
								_unref(formData).allow_pdf_to_team
							) = $event)),
                    options: yesNoOption
                  }, null, 8, ["modelValue"])
                ]),
                _createVNode(VirtualMailboxTeamMembers),
                _createVNode(_unref(UiCard), { theme: "white" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(UiCardDivider), {
                      title: "Danger zone",
                      subtitle: "By removing this virtual mailbox you won't be able to use it to receive virtual mails."
                    }),
                    _createVNode(_unref(UiButton), {
                      onClick: 
								triggerDeleteVirtualMailbox
							,
                      theme: "danger-outlined",
                      type: "button"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Delete Virtual Mailbox ")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ])
            ], 64))
      ]),
      _: 1
    }),
    _hoisted_16
  ]))
}
}

})